import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["type", "eer", "ceer"];

  connect() {
    this.#updateFields();
  }

  change() {
    this.#updateFields();
  }

  #updateFields() {
    const type = this.typeTarget.value;
    this.#toggle(this.eerTarget, type === "central_ac");
    this.#toggle(this.ceerTarget, type === "room_ac");
  }

  #toggle(target, visible) {
    target.classList.toggle("hidden", !visible);
    target.querySelector("input").required = visible;
  }
}
